import type { Options } from 'highcharts';

export const semiCircleSimpleIndicatorOptions: Options = {
  chart: {
    type: 'pie',
    backgroundColor: 'transparent',
    height: 70,
    width: 95,
    plotBorderWidth: 0,
    plotShadow: false,
    spacing: [0, 0, 0, 0],
  },
  accessibility: {
    enabled: true,
  },
  title: {
    text: undefined,
  },
  credits: {
    enabled: false,
  },
  tooltip: {
    enabled: false,
  },
  plotOptions: {
    pie: {
      dataLabels: {
        enabled: false,
      },
      startAngle: -120,
      endAngle: 120,
      center: ['50%', '90%'],
      size: '95px',
      innerSize: '75%',
      borderWidth: 0,
      borderRadius: 30,
      states: {
        hover: {
          enabled: false,
        },
      },
    },
  },
  exporting: {
    enabled: false,
  },
  series: [],
};
